/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Input/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Input({
  children,
  viewPath = "/DesignSystem/Input",
  borderBottomLeftRadius = 4,
  borderBottomRightRadius = 4,
  borderTopLeftRadius = 4,
  borderTopRightRadius = 4,
  autoComplete = "on",
  autoFocus,
  className,
  fontFamily = "Inter",
  fontSize = 16,
  fontWeight = 300,
  marginBottom = 0,
  marginTop = 4,
  onBlur,
  onChange,
  onFocus,
  onKeyUp,
  paddingRight = 8,
  placeholder,
  innerRef,
  textTransform = "capitalize",
  type = "text",
  value,
  width = "auto"
  
}) {
  return (<React.Fragment
>
<input
 type={
                type === 'phone' ? 'tel' :
                type === 'secure' ? 'password' : type}
inputMode={type === 'number' || type === 'phone'? "numeric" : undefined}
pattern={type === 'number' || type === 'phone'? "[0-9]*" : undefined}
  data-testid="Input.Input"
  data-view-path={viewPath}
 autoComplete={autoComplete}
 autoFocus={autoFocus}
 onBlur={onBlur}
 onChange={(e) => onChange && onChange(e, e.target.value)}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 placeholder={placeholder}
 ref={innerRef}
 value={value}
 style={{'--bblr-1-56VAy': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-2-56VAy': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-3-56VAy': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-4-56VAy': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--ff-5-56VAy': fontFamily,'--fs-6-56VAy': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--fw-7-56VAy': fontWeight,'--mb-8-56VAy': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--mt-9-56VAy': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--pr-10-56VAy': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--tt-11-56VAy': textTransform,'--w-12-56VAy': typeof width === 'number' ? `${width}px` : width}}
 className={`views-capture ${className} ${styles.Input1}`}
/>
{children}
</React.Fragment>)
}